// extracted by mini-css-extract-plugin
export default {"cls1":"fkO4REKLNHx5amAtSl03","cls2":"wFmPf0icR5QMR4MxTzNj fkO4REKLNHx5amAtSl03"};